import { IInterventionMedication } from './../medlogic/iintervention-medication';

export interface IPostCheckMedicationStockResponse {
    medications: IInterventionMedication[];
}
